import React from 'react';
import DynamicPracticePage from '../../components/common/DynamicPracticePage';
import { TopicItem } from '../../components/common/PracticeContentLayout';

// Define the topic structure (same as before)
const topics: TopicItem[] = [
  {
    id: 'lld-introduction',
    title: 'LLD Introduction',
    completed: false,
    children: [
      { id: 'intro-1', title: 'Introduction to LLD', completed: false },
      { id: 'intro-2', title: 'Why LLD Matters', completed: false },
      { id: 'intro-3', title: 'LLD vs HLD', completed: false },
      { id: 'intro-4', title: 'LLD Interview Process', completed: false },
      { id: 'lld-intro-quiz', title: 'Quiz', completed: false },
    ],
  },
  {
    id: 'oop-fundamentals',
    title: 'OOP Fundamentals',
    completed: false,
    children: [
      { id: 'oop-1', title: 'Classes and Objects', completed: false },
      { id: 'oop-2', title: 'Encapsulation', completed: false },
      { id: 'oop-3', title: 'Inheritance', completed: false },
      { id: 'oop-4', title: 'Polymorphism', completed: false },
      { id: 'oop-5', title: 'Abstraction', completed: false },
      { id: 'oop-6', title: 'Interfaces', completed: false },
      { id: 'oop-7', title: 'Abstract Classes', completed: false },
      { id: 'oop-8', title: 'OOP Best Practices', completed: false },
    ],
  },
  {
    id: 'class-relationships',
    title: 'Class Relationships',
    completed: false,
    children: [
      { id: 'rel-1', title: 'Association', completed: false },
      { id: 'rel-2', title: 'Aggregation', completed: false },
      { id: 'rel-3', title: 'Composition', completed: false },
      { id: 'rel-4', title: 'Inheritance', completed: false },
      { id: 'rel-5', title: 'Dependency', completed: false },
      { id: 'rel-6', title: 'Real-world Examples', completed: false },
    ],
  },
  {
    id: 'design-principles',
    title: 'Design Principles',
    completed: false,
    children: [
      { id: 'dp-1', title: 'DRY Principle', completed: false },
      { id: 'dp-2', title: 'KISS Principle', completed: false },
      { id: 'dp-3', title: 'YAGNI Principle', completed: false },
      { id: 'dp-4', title: 'Separation of Concerns', completed: false },
      { id: 'dp-5', title: 'Single Responsibility', completed: false },
      { id: 'dp-6', title: 'Open/Closed Principle', completed: false },
      { id: 'dp-7', title: 'Liskov Substitution', completed: false },
      { id: 'dp-8', title: 'Interface Segregation', completed: false },
    ],
  },
  {
    id: 'solid-principles',
    title: 'SOLID Principles',
    completed: false,
    children: [
      { id: 'solid-1', title: 'Single Responsibility Principle', completed: false },
      { id: 'solid-2', title: 'Open/Closed Principle', completed: false },
      { id: 'solid-3', title: 'Liskov Substitution Principle', completed: false },
      { id: 'solid-4', title: 'Interface Segregation Principle', completed: false },
      { id: 'solid-5', title: 'Dependency Inversion Principle', completed: false },
      { id: 'solid-6', title: 'SOLID in Practice', completed: false },
    ],
  },
  {
    id: 'uml',
    title: 'UML',
    completed: false,
    children: [
      { id: 'uml-1', title: 'Introduction to UML', completed: false },
      { id: 'uml-2', title: 'Class Diagrams', completed: false },
      { id: 'uml-3', title: 'Sequence Diagrams', completed: false },
      { id: 'uml-4', title: 'Activity Diagrams', completed: false },
      { id: 'uml-5', title: 'UML Best Practices', completed: false },
    ],
  },
  {
    id: 'design-patterns',
    title: 'Design Patterns',
    completed: false,
    children: [
      {
        id: 'patterns-intro',
        title: 'Intro to Design Patterns',
        completed: false,
      },
      {
        id: 'creational',
        title: 'Creational',
        completed: false,
        children: [
          { id: 'singleton', title: 'Singleton', completed: false },
          { id: 'factory-method', title: 'Factory Method', completed: true },
          { id: 'abstract-factory', title: 'Abstract Factory', completed: false },
          { id: 'builder', title: 'Builder', completed: false },
          { id: 'prototype', title: 'Prototype', completed: false },
        ],
      },
      {
        id: 'structural',
        title: 'Structural',
        completed: false,
        children: [
          { id: 'adapter', title: 'Adapter', completed: false },
          { id: 'bridge', title: 'Bridge', completed: false },
          { id: 'composite', title: 'Composite', completed: false },
          { id: 'decorator', title: 'Decorator', completed: false },
          { id: 'facade', title: 'Facade', completed: false },
          { id: 'flyweight', title: 'Flyweight', completed: false },
          { id: 'proxy', title: 'Proxy', completed: false },
        ],
      },
      {
        id: 'behavioral',
        title: 'Behavioral',
        completed: false,
        children: [
          { id: 'observer', title: 'Observer', completed: false },
          { id: 'strategy', title: 'Strategy', completed: false },
          { id: 'command', title: 'Command', completed: false },
          { id: 'state', title: 'State', completed: false },
          { id: 'template-method', title: 'Template Method', completed: false },
          { id: 'visitor', title: 'Visitor', completed: false },
          { id: 'chain-of-responsibility', title: 'Chain of Responsibility', completed: false },
          { id: 'mediator', title: 'Mediator', completed: false },
          { id: 'memento', title: 'Memento', completed: false },
          { id: 'iterator', title: 'Iterator', completed: false },
        ],
      },
      { id: 'patterns-quiz', title: 'Quiz', completed: false },
    ],
  },
];

const LLDPractice: React.FC = () => {
  return (
    <DynamicPracticePage
      topicType="lld"
      topics={topics}
      title="Master LLD Interviews"
    />
  );
};

export default LLDPractice;
